import styled from 'styled-components';

const FooterInfo = styled.div`
  display: flex;
`;

export default FooterInfo;
